import axios from 'axios';
import apiConfig from '../config/apiConfig';

const BASE_URL = apiConfig.BASE_URL;

function getStoredToken() {
  try {
    const persistRoot = localStorage.getItem('persist:root');
    if (persistRoot) {
      const parsed = JSON.parse(persistRoot);
      if (parsed.auth) {
        const authState = JSON.parse(parsed.auth);
        return authState.token;
      }
    }
  } catch (e) {
    console.warn('Could not read token from redux-persist:', e);
  }
  return localStorage.getItem('storehub_token') || sessionStorage.getItem('storehub_token');
}

function getAuthHeaders() {
  const token = getStoredToken();
  if (!token || token === 'null' || token === 'undefined') {
    throw new Error('Authentication required. Please log in again.');
  }
  return { headers: { Authorization: 'Bearer ' + token } };
}

export const fetchAnalyticsOverview = async (params) => {
  const auth = getAuthHeaders();
  const response = await axios.get(BASE_URL + '/api/analytics/overview', { ...auth, params: params || {} });
  return response.data;
};

export const fetchSalesChart = async (params) => {
  const auth = getAuthHeaders();
  const response = await axios.get(BASE_URL + '/api/analytics/sales', { ...auth, params: params || {} });
  return response.data;
};

export const fetchOrdersChart = async (params) => {
  const auth = getAuthHeaders();
  const response = await axios.get(BASE_URL + '/api/analytics/orders', { ...auth, params: params || {} });
  return response.data;
};

export const fetchRevenueByStore = async (params) => {
  const auth = getAuthHeaders();
  const response = await axios.get(BASE_URL + '/api/analytics/revenue-by-store', { ...auth, params: params || {} });
  return response.data;
};
